import { Link } from "react-router-dom";
import { MapPin, Phone } from "lucide-react";
import { SITE } from "../data/menu";
import { useSettings } from "../site-settings";
import { Blossom, Flourish } from "./decor";

export const Footer = () => {
  const { menuVisible } = useSettings();
  return (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[#9B2C2C] text-white">
    <div className="pointer-events-none absolute -left-10 top-8 opacity-20">
      <Blossom className="h-44 w-44 text-[#C9A227]" />
    </div>
    <div className="pointer-events-none absolute -bottom-12 -right-8 opacity-20">
      <Blossom className="h-52 w-52 text-[#C9A227]" />
    </div>

    <div className="relative mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-20">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <p className="font-serif text-3xl font-bold">BLOOMORA</p>
          <p className="font-hindi mt-1 text-lg text-[#E8B4B8]">ब्लूमोरा</p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/80">
            {SITE.footerLine}. A pure vegetarian, multi-cuisine family table in the heart of Dumka.
          </p>
        </div>

        <div>
          <p className="mb-4 font-serif text-xl text-[#C9A227]">Visit Us</p>
          <p className="flex items-start gap-2 text-sm leading-relaxed text-white/85">
            <MapPin size={16} className="mt-0.5 shrink-0 text-[#C9A227]" />
            {SITE.address}
          </p>
          <a
            href={SITE.mapsLink}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-directions-link"
            className="mt-3 inline-block text-sm text-[#C9A227] underline-offset-4 transition-colors hover:text-[#E8C95A] hover:underline"
          >
            Get Directions on Google Maps
          </a>
        </div>

        <div>
          <p className="mb-4 font-serif text-xl text-[#C9A227]">Talk to Us</p>
          <a
            href={SITE.phoneHref}
            data-testid="footer-phone-link"
            className="flex items-center gap-2 text-sm text-white/85 transition-colors hover:text-white"
          >
            <Phone size={16} className="text-[#C9A227]" /> {SITE.phone}
          </a>
          <div className="mt-5 flex flex-wrap gap-4 text-sm">
            {["Menu", "Gallery", "About", "Contact"].filter((l) => menuVisible || l !== "Menu").map((l) => (
              <Link
                key={l}
                to={`/${l.toLowerCase()}`}
                data-testid={`footer-link-${l.toLowerCase()}`}
                className="text-white/80 underline-offset-4 transition-colors hover:text-[#C9A227] hover:underline"
              >
                {l}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center gap-4 border-t border-white/15 pt-8 text-center">
        <Flourish className="h-4 w-48 opacity-90" />
        <p data-testid="footer-tagline" className="font-serif text-lg italic text-[#E8B4B8]">
          {SITE.footerLine}
        </p>
        <p className="text-xs text-white/60">© {new Date().getFullYear()} Bloomora Family Restaurant, Dumka</p>
      </div>
    </div>
  </footer>
  );
};
